import React from 'react';
import { Alert } from "flowbite-react";
import { BiErrorAlt, BiError } from "react-icons/bi";
import { Config } from "../../app.config";
import { useSearchContext } from "../utils/Context";
var Error = function Error() {
  var _error$message;
  var _useSearchContext = useSearchContext(),
    options = _useSearchContext.options,
    error = _useSearchContext.error;
  var errorMessage = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : "An unknown error has occurred. Please try again later.";
  if (errorMessage === "Timeout. Maybe slow down a bit") {
    var additionalContent = /*#__PURE__*/React.createElement("div", {
      className: "mt-4 text-yellow-800 dark:text-yellow-800"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-xl font-bold mb-6"
    }, errorMessage), /*#__PURE__*/React.createElement("p", {
      className: "text-base"
    }, "Try narrowing your time range on the search or add more words to your search query and search again. You might also be searching too many times slow down a little bit."));
    return /*#__PURE__*/React.createElement("div", {
      className: "p-12 w-full"
    }, /*#__PURE__*/React.createElement(Alert, {
      color: "warning",
      icon: BiError,
      additionalContent: additionalContent
    }, /*#__PURE__*/React.createElement("h2", {
      className: "text-2xl font-semibold text-yellow-800 dark:text-yellow-800"
    }, "Your search might be too broad")));
  } else {
    var _additionalContent = /*#__PURE__*/React.createElement("div", {
      className: "mt-4 text-red-800 dark:text-red-800"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-xl font-bold mb-6"
    }, errorMessage), /*#__PURE__*/React.createElement("p", {
      className: "text-base mb-3"
    }, "There is probably an issue with API that provides the search results data."), /*#__PURE__*/React.createElement("p", {
      className: "text-base"
    }, "In the meantime, you can use this ", /*#__PURE__*/React.createElement("a", {
      href: "https://www.google.com/search?q=site:reddit.com/r/".concat(Config.defaultSubreddit),
      className: "underline font-semibold",
      target: "_blank"
    }, "Google search query"), " to help find what you are looking for, just add your search to the existing text that helps narrow the search to the ", Config.defaultSubreddit, " subreddit."));
    return /*#__PURE__*/React.createElement("div", {
      className: "p-12 w-full"
    }, /*#__PURE__*/React.createElement(Alert, {
      color: "failure",
      icon: BiErrorAlt,
      additionalContent: _additionalContent
    }, /*#__PURE__*/React.createElement("h2", {
      className: "text-2xl font-semibold text-red-800 dark:text-red-800"
    }, "An Error Has Occurred")));
  }
};
export default Error;